import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
//获取地址列表接口
export function selByList(data){
	return post('/admin/appCAddress/selByList',data)
}
//新增地址
export function addAppCAddress(data){
	return post('/admin/appCAddress/addAppCAddress',data)
}
//删除地址
export function delAppCAddress(data){
	return post('/admin/appCAddress/delAppCAddress',data)
}
//编辑地址
export function upAppCAddress(data){
	return post('/admin/appCAddress/upAppCAddress',data)
}